const pageTitles = {
  "/": "Agentic AI, Blockchain and Salesforce Solutions",

  // Company
  "/about-us": "About Us",
  "/contact-us": "Contact",
  "/portfolio": "Portfolio",
  "/client-testimonials": "Client Testimonials",
  "/current-openings": "Current Openings",
  "/life-at-metaqualt": "Life at Metaqualt",
  "/life-at-metaqualt/detail": "Life at Metaqualt Detail",

  // Blog
  "/blog": "Blog",
  "/blog/:slug": "Blog Detail",

  // White Paper
  "/white-paper": "White Paper",
  "/white-paper/:slug": "White Paper Detail",

  // Case Study
  "/case-study": "Case Study",

  // Development Services
  "/web-development": "Web Development",
  "/cms-development": "CMS Development (WordPress)",
  "/reactjs-development": "ReactJS Development",
  "/mobile-app-development": "Mobile App Development",
  "/android-app-development": "Android App Development",
  "/ios-app-development": "iOS App Development",
  "/ux-ui-design": "UI / UX Design",

  // AI / ML / Data
  "/machine-learning": "Machine Learning",
  "/quality-engineering": "Quality Engineering",
  "/artificial-intelligence": "Artificial Intelligence",
  "/data-science": "Data Science",

  // eCommerce
  "/eCommerce-development": "E-Commerce Development",
  "/ecommerce-solutions": "E-Commerce Solutions",

  // Cloud & Enterprise
  "/cloud-consulting": "Cloud Consulting",
  "/cloud-app-development": "Cloud App Development",
  "/microsoft-dotnet": "Microsoft .NET Development",
  "/application-migration": "Application Migration",
  "/crm-development": "CRM Development",
  "/software-development": "Software Development",
  "/power-bi": "Power BI",
  "/tableau": "Tableau",
  "/database-management": "Database Management",
  "/application-integration": "Application Integration",

  // Salesforce
  "/salesforce-consulting-services": "Salesforce Consulting",
  "/salesforce-lightning-services": "Salesforce Lightning",
  "/salesforce-implementation": "Salesforce Implementation",
  "/salescloud-consulting": "Sales Cloud Consulting",
  "/salesforce-exchange": "Salesforce AppExchange",

  // Hire Developers
  "/hire-web-developers": "Hire Web Developers",
  "/hire-php-developers": "Hire PHP Developers",
  "/hire-react-native-developers": "Hire React Native Developers",
  "/hire-mean-stack-developers": "Hire MEAN Stack Developers",
  "/hire-full-stack-developers": "Hire Full Stack Developers",
  "/hire-flutter-developers": "Hire Flutter Developers",
  "/hire-python-developers": "Hire Python Developers",
  "/hire-laravel-developers": "Hire Laravel Developers",
  "/hire-nodejs-developers": "Hire Node.js Developers",
  "/hire-reactjs-developers": "Hire ReactJS Developers",
  "/hire-iphone-app-developer": "Hire iOS Developers",
  "/hire-vuejs-developer": "Hire VueJS Developers",
  "/hire-android-app-developer": "Hire Android App Developers",
  "/business-analyst": "Business Analysts",
  "/project-managers": "Project Managers",
  "/software-testers": "Software Testers",
  "/hire-designers": "Hire Designers",
  "/hire-ui-ux-developers": "Hire UI/UX Developers",

  // Industry Solutions
  "/startup-solutions": "Startup Solutions",
  "/enterprise-solutions": "Enterprise Solutions",
  "/devops-solutions": "DevOps Solutions",
  "/cloud-solutions": "Cloud Solutions",
  "/on-demand-business-solutions": "On-Demand Business Solutions",
  "/fitness-wellness-app-solutions": "Fitness & Wellness App Solutions",
  "/business-app-solution": "Business App Solutions",
  "/travel-app-solutions": "Travel App Solutions",
  "/real-estate-app-solution": "Real Estate App Solutions",
  "/healthcare-app-solution": "Healthcare App Solutions",
  "/fintech-app-solution": "Fintech App Solutions",

  "/blockchain": "Blockchain",
  "/digital-marketing": "Digital Marketing",
  "/saas-app-development": "SaaS Application Development",
  "/retail-business": "Retail Business Solutions",
  "/ecommerce-app": "E-Commerce App Solutions",
  "/enterprise-solution": "Enterprise Solution",
};

export default pageTitles;
